import React from 'react';
import { IconButton } from '@paypalcorp/pp-react';
import getLocaleMessages from '../../utils/localesMessages';
import { Field, change, getFormValues } from 'redux-form';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import BasicInputField from '../fields/BasicInputField';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const {
  removeButton,
  upArrow,
  downArrow,
  programNameDefaultField,
  programName,
} = getLocaleMessages('buttonsV3/programs');

const ProgramFieldV3 = ({
  position,
  showUpArrow,
  showDownArrow,
  showDelete,
  programNames,
  dispatch,
}) => {
  const renderTextField = (props) => {
    return <BasicInputField {...props} />;
  };

  const onChangeProgram = (value) => {
    programNames[position] = value;
    const newProgramNames = [...programNames];
    change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames);
  };

  const moveProgramUp = () => {
    let newProgramNames = [...programNames];
    const tempProgram = newProgramNames[position];

    newProgramNames[position] = newProgramNames[position - 1];
    newProgramNames[position - 1] = tempProgram;

    dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));

    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position].join(''),
        newProgramNames[position]
      )
    );
    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position - 1].join(''),
        newProgramNames[position - 1]
      )
    );
  };

  const moveProgramDown = () => {
    let newProgramNames = [...programNames];
    const tempProgram = newProgramNames[position];

    newProgramNames[position] = newProgramNames[position + 1];
    newProgramNames[position + 1] = tempProgram;

    dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));

    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position].join(''),
        newProgramNames[position]
      )
    );
    dispatch(
      change(
        BTN_FACTORY_V3_FORM,
        ['programInput', position + 1].join(''),
        newProgramNames[position + 1]
      )
    );
  };

  const removeProgram = () => {
    const newProgramNames = [];
    for (let i = 0; i < programNames.length; i++) {
      if (i !== position) {
        newProgramNames.push(programNames[i]);
      }
      if (i === programNames.length - 1) {
        dispatch(change(BTN_FACTORY_V3_FORM, ['programInput', i].join(''), ''));
      }
    }

    for (let i = 0; i < newProgramNames.length; i++) {
      dispatch(
        change(
          BTN_FACTORY_V3_FORM,
          ['programInput', i].join(''),
          newProgramNames[i]
        )
      );
    }

    dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));
  };

  return (
    <div className="program-row">
      <Field
        name={`programInput${position}`}
        id={`programInput${position}`}
        label={
          position === 0
            ? programNameDefaultField.replace('{value}', position + 1)
            : programName.replace('{value}', position + 1)
        }
        className="program-input"
        onChange={(e) => onChangeProgram(e.target.value)}
        onBlur={(e) => onChangeProgram(e.target.value)}
        component={renderTextField}
      />
      <div className={`program-buttons ${!showDelete ? 'display-none' : ''}`}>
        <IconButton
          iconName="arrow-up"
          id={`UpArrow${position}`}
          onClick={moveProgramUp}
          className={`${!showUpArrow ? 'hide-icon' : ''}`}
        >
          {upArrow}
        </IconButton>
        <IconButton
          iconName="arrow-down"
          id={`DownArrow${position}`}
          onClick={moveProgramDown}
          className={`${!showDownArrow ? 'hide-icon' : ''}`}
        >
          {downArrow}
        </IconButton>
        <IconButton
          iconName="trash"
          id={`removeProgram${position}`}
          onClick={removeProgram}
          className={`${!showDelete ? 'hide-icon' : ''} icon-trash`}
        >
          {removeButton}
        </IconButton>
      </div>
    </div>
  );
};

ProgramFieldV3.propTypes = {
  position: PropTypes.number,
  showUpArrow: PropTypes.bool,
  showDownArrow: PropTypes.bool,
  showDelete: PropTypes.bool,
  programNames: PropTypes.array,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
  const formValues = getFormValues(BTN_FACTORY_V3_FORM)(state) || {};

  return {
    programNames: formValues.programNames,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgramFieldV3);
